<div class="metric-card">
    <div class="icon" *ngIf="icon"><img [src]="icon" alt="icon" /></div>
    <div class="title">{{ title }}</div>
    <div class="value">{{ value }}</div>
    <div class="subtitle" *ngIf="subtitle">{{ subtitle }}</div>
</div>